import { CompanyProvidersResponse } from "../entities/company/PaymentProvider/CompanyProvidersResponse";
import { ProvidersListResponse } from "../entities/company/PaymentProvider/ProvidersListResponse";
import { SetProviderRequest } from "../entities/company/PaymentProvider/SetProviderRequest";
import { SetProviderResponse } from "../entities/company/PaymentProvider/SetProviderResponse";
import {
  ProviderCurrencyListResponse,
  SetProviderCurrencyRequest,
  SetProviderCurrencyResponse
} from "../entities/company/PaymentProvider/ProviderCurrency";
import RequestService from "./RequestService";

class CompanyPaymentProviderService {
  /**
   * Lista los proveedores disponibles en el sistema
   * GET /paymentlinkprovider/list
   */
  public static listPaymentProviders(): Promise<Error | ProvidersListResponse> {
    return RequestService.get("/paymentlinkprovider/list", {});
  }

  /**
   * Obtiene los proveedores configurados para la compañía actual
   * GET /paymentlinkprovider/providersbycompany
   */
  public static getProvidersByCompany(): Promise<
    Error | CompanyProvidersResponse
  > {
    return RequestService.get("/paymentlinkprovider/providersbycompany", {});
  }

  /**
   * Registra o actualiza un proveedor de pago para la compañía
   * POST /paymentlinkprovider/setprovider
   * @param request Datos del proveedor a configurar
   */
  public static setProvider(
    request: SetProviderRequest
  ): Promise<Error | SetProviderResponse> {
    return RequestService.post("/paymentlinkprovider/setprovider", request);
  }

  /**
   * Elimina un proveedor de pago de la compañía
   * DELETE /paymentlinkprovider/{paymentLinkProviderId}
   * @param paymentLinkProviderId ID del proveedor a eliminar
   */
  public static deleteProvider(
    paymentLinkProviderId: number
  ): Promise<Error | void> {
    return RequestService.delete(
      `/paymentlinkprovider/${paymentLinkProviderId}`,
      {}
    );
  }

  /**
   * Obtiene la configuración de segmentos para la pasarela de pagos
   * GET /paymentlinkprovider/getsegments
   */
  public static getSegmentsConfig(): Promise<
    | Error
    | {
        segmentIds?: number[];
        segments?: any[];
        list?: { name: string; segmentId: number }[];
      }
  > {
    return RequestService.get("/paymentlinkprovider/getsegments", {});
  }

  /**
   * Guarda la configuración de segmentos para la pasarela de pagos
   * POST /paymentlinkprovider/setsegments
   * @param segmentIds Array de IDs de segmentos
   */
  public static setSegmentsConfig(segmentIds: number[]): Promise<Error | void> {
    return RequestService.post("/paymentlinkprovider/setsegments", {
      segmentIds
    });
  }

  /**
   * Obtiene las monedas configuradas para un proveedor de pago
   * GET /paymentlinkprovidercurrency/currencies/{paymentLinkProviderId}
   * @param paymentLinkProviderId ID del proveedor de pago
   */
  public static getProviderCurrencies(
    paymentLinkProviderId: number
  ): Promise<Error | ProviderCurrencyListResponse> {
    return RequestService.get(
      `/paymentlinkprovidercurrency/currencies/${paymentLinkProviderId}`,
      {}
    );
  }

  /**
   * Crea o actualiza una moneda para un proveedor de pago
   * POST /paymentlinkprovidercurrency/setcurrency
   * @param request Datos de la moneda a configurar
   */
  public static setProviderCurrency(
    request: SetProviderCurrencyRequest
  ): Promise<Error | SetProviderCurrencyResponse> {
    return RequestService.post(
      "/paymentlinkprovidercurrency/setcurrency",
      request
    );
  }

  /**
   * Elimina una moneda de un proveedor de pago
   * DELETE /paymentlinkprovidercurrency/delete/{paymentLinkProviderCurrencyId}
   * @param paymentLinkProviderCurrencyId ID de la moneda del proveedor a eliminar
   */
  public static deleteProviderCurrency(
    paymentLinkProviderCurrencyId: number
  ): Promise<Error | { deleted: boolean }> {
    return RequestService.delete(
      `/paymentlinkprovidercurrency/delete/${paymentLinkProviderCurrencyId}`,
      {}
    );
  }
}

export default CompanyPaymentProviderService;
